import Vue from 'vue'
const moment = require('moment')

moment.relativeTimeThreshold('h', 24);

Vue.use(require('vue-moment'), {
    moment
});